<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import upresult from './upresult/index.vue'
	import upfilesuccess from './upfilesuccess/index.vue'
	import kmdetail from './kmdetail/index.vue'
	export default {
		name: 'subject',
		components: {
			upresult,
			upfilesuccess,
			kmdetail
		},
		data: function() {
			return {
				headlist: getdata().headlist,
				chooseindex: 0
			};
		},
		created() {
		},
		methods: {
			forchooseindex(e) {
				this.chooseindex = e
			}
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
